module.exports = __webpack_public_path__ + "img/logo-white.57b763d7.svg";